import { render } from "./front-layout.vue?vue&type=template&id=cae7ca86&scoped=true&ts=true"
import script from "./front-layout.vue?vue&type=script&lang=ts"
export * from "./front-layout.vue?vue&type=script&lang=ts"

import "./front-layout.vue?vue&type=style&index=0&id=cae7ca86&lang=scss&scoped=true"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae7ca86"]])

export default __exports__